import axios from 'axios';
import { toast } from 'react-toastify';

const getImgUrl = (id, resourceId) => `/resource/v1/resources/${resourceId}/file/${id}`;

export function submitFileAsset({
	assetUploadURL,
	e,
	documentLabel,
	setUploading,
	setDocument,
	setDocumentLabel,
	setDocumentSize,
	setDocumentExtension,
	setDocumentFilename,
	setAttachmentId,
	verifyForm,
}) {
	if (setUploading) {
		setUploading(true);
	}

	if (!document) {
		setDocument(e.target.files[0].name);
	}
	if (setDocumentSize) {
		setDocumentSize(e.target.files[0].size);
	}

	const formData = new FormData();
	formData.append('files', e.target.files[0]);
	return axios({
		method: 'POST',
		url: assetUploadURL,
		data: formData,
		headers: { 'Content-Type': 'multipart/form-data' },
	}).then(res => {
		if (res.status === 201) {
			res.data.extension = getExtension(res.data.fileName);
			setDocument(res.data);
			if (setDocumentExtension) {
				setDocumentExtension(res.data.extension);
			}
			if (setAttachmentId) {
				setAttachmentId(res.data.id);
			}
			if (setDocumentFilename) {
				setDocumentFilename(res.data.fileName);
			}

			if (verifyForm) {
				verifyForm('ATTACHMENT');
			}

			toast('Document uploaded', {
				autoClose: 3000,
				type: toast.TYPE.SUCCESS,
			});
		} else {
			console.log('upload status: ' + res.status);
			setDocument(null);
			if (setDocumentSize) {
				setDocumentSize(null);
			}
			if (setDocumentLabel) {
				setDocumentLabel(null);
			}
		}

		if (setUploading) {
			setUploading(false);
		}

		return res;
	});
}

export function getImage({ id, resourceId, setImgUrl }) {
	axios({
		method: 'GET',
		url: getImgUrl(id, resourceId),
	}).then(
		response => {
			setImgUrl(response.data);
		},
		error => {
			console.log(error);
		},
	);
}

export const formatBytes = bytes => {
	if (bytes === 0) return '';
	const k = 1024;
	const dm = 0;
	const sizes = ['bytes', 'kb', 'mb'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
};

export function getExtension(filename) {
	return filename.split('.').pop();
}

export const loadImages = ({ url: url, objects, setImagesLoaded }) => {
	const getResourceImage = r => {
		const loadUrl = url(r.imageId);
		return axios({
			method: 'GET',
			url: loadUrl,
		}).then(
			resp => {
				r.imageUrl = resp.data;
				return resp;
			},
			error => {
				console.log(error);
			},
		);
	};

	const promiseArray = [];
	if (objects) {
		objects.forEach(c => {
			if (c.imageId) {
				promiseArray.push(getResourceImage(c));
			}
		});

		if (promiseArray.length > 0) {
			return Promise.all(promiseArray)
				.then(responses => {
					if (responses.length > 0) {
						setImagesLoaded(true);
					}
					return objects;
				})
				.catch(error => {
					console.log(error); // zzmatt
				});
		} else {
			promiseArray.push(Promise.resolve());
			return Promise.all(promiseArray).then(() => {
				setImagesLoaded(true);
				return objects;
			});
		}
	}
};
